import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Loading from "./components/Loading";
import { TodoContextProvider } from "./contexts/TodoContext";

const Home = lazy(() => import("./pages/Home"));
const Todo = lazy(() => import("./pages/Todo"));

const NotFound = lazy(() => import("./pages/404/NotFound"));

function App() {
  return (
    <Router>
      <Suspense fallback={<Loading />}>
        <TodoContextProvider>
            <Routes>
              {/* auth */}
              <Route path="/" element={<Home />} />
              <Route path="/:id" element={<Todo />} />

              {/* Not Found */}
              <Route path="/not-found" element={<NotFound />} />
              <Route
                path="*"
                element={<Navigate to="/not-found" replace />}
              />
            </Routes>
        </TodoContextProvider>
      </Suspense>
    </Router>
  );
}

export default App;
